<template>
  <div class="file-dialog-body">
	<div class="file-dialog-content">
		<div style="width:400px">
            <p>商品名称：</p> <div class='span-box'>{{productname}}</div>
        </div>
        <div style="width:300px">
            <p>单位名称：</p> <div class='span-box'>{{editData.unitName}}</div>
        </div>
        <div style="width:300px">
            <p>单位规格：</p> <div class='span-box'>{{editData.specName}}</div>
        </div>
        <div style="width:300px">
            <p>标准重量：</p> <div class='span-box'>{{editData.standardWeight}}</div>
        </div>
         <div>
            <p>默认价格：</p> <div class='span-box'>{{editData.defaultPrice}}</div>
        </div>
		<!-- <p>单位规格：</p><div class='span-box'>{{editData.unit}}</div>
		<p>标准重量：</p><div class='span-box'>{{editData.unit}}</div>
		<p>商品统一单价：</p><div class='span-box'>{{editData.unit}}</div>
		<p>自定义单价：</p> -->
        <div>
            <p>自定义单价：</p>
            <div class='span-box'>
				<el-input  type='number' :class="+editData.defaultPrice > +customePrice ? 'isRed':''" class="input-box" size='mini' @blur="onBlur" v-model='customePrice'></el-input>
				<span v-if="+editData.defaultPrice > +customePrice" style="color:red">
					小于默认价格
				</span>
            </div>

        </div>
        <div>
            <p>库存：</p>
            <div class='span-box'>
				<el-input class="input-box" onkeyup="value=value.replace(/[^0-9]/g,'')" onpaste="value=value.replace(/[^0-9]/g,'')" oncontextmenu = "value=value.replace(/[^0-9]/g,'')" v-model="inventory" @blur="onBlur1" size='mini'></el-input>
            </div>
        </div>
		<!-- <div>
            <p>最小订货数：</p>
			<div v-if='minbuycnt === 0' style="width:200px;color:red;float:right;overflow: hidden;margin-right:100px">
				客户默认最小订货数量1，界面不做最小订货数提示
			</div>
			<div v-else style="width:200px;color:red;float:right;overflow: hidden;margin-right:100px">
				客户默认最小订货数量[{{minbuycnt}}]，界面会做最小订货数提示
			</div>
            <div class='span-box'>
				<el-input-number :max='9999' class="input-box" @change="minbuycntChange" size='mini' :precision="0" :min="0" :step="1" v-model='minbuycnt'></el-input-number>
            </div>
        </div> -->
		<div style="text-align: right;margin: 10px 0;">
			<el-button size='small' type="primary" style="" plain class='fx-big-btn' @click="addBarcode">新增</el-button>
		</div>
		<!-- <svg id="barcode0"></svg>
		<svg id="barcode1"></svg> -->
		<div class="table-box">
				<el-table
				class="grid-content"
				:data="tableData"
				size='mini'
				border>
				<el-table-column
				prop="input"
				label="商品条形码"
				align="center"
				width="160">
				<template slot-scope="scope">
					<!-- @keydown.native="channelInputLimit" -->
					<el-input type="text" @input="barcodeInput($event, scope.$index)" @mousewheel.native.prevent placeholder="最多输入13位纯数字" size='mini' maxlength="13" v-model='scope.row.barcode'></el-input>
				</template>
				</el-table-column>
				<el-table-column
				prop="img"
				label="条形码图片"
				align="center">
				<template slot-scope="scope">
					<svg :id="'barcode' + scope.$index" style="height: 62px;"></svg>
					<!-- jsbarcode-format="ean13"
                           :jsbarcode-value= scope.row.barcode
                            jsbarcode-textmargin="0"
                            jsbarcode-fontoptions="bold" -->
				</template>
				</el-table-column>
				<el-table-column fixed="right" label="操作" width="120" align="center">
					<template slot-scope="scope">
						<el-button type='text' size="mini" icon="el-icon-delete" @click="delItem(scope.row, scope.$index)">删除</el-button>
					</template>
				</el-table-column>
			</el-table>
		</div>
	</div>
	<div class="btn-box">
		<el-button type="primary" size='small' plain class="btn" @click="cancel">取消</el-button>
		<el-button type="primary" size='small' plain class="btn" @click="save">确认</el-button>
	</div>
  </div>
</template>

<script>
import JsBarcode from 'jsbarcode'
export default {
	name: 'fileDialog',
	props: {
		editData: Object,
		productId: String,
		shopid: String,
		productname: String,
		isAdd: Boolean
	},
	data () {
		return {
			inventory: '',
			customePrice: '',
			minbuycnt: 0,
			tableData: []
		}
	},
	watch: {
		isAdd: {
			handler (val) {
				if (val === true) {
					this.customePrice = this.editData.customPrice
					this.inventory = this.editData.inventory
					this.minbuycnt = this.editData.minbuycnt
				}
			},
			immediate: true
		},
		editData: {
			handler (val) {
				// console.log(val)
				this.customePrice = val.customPrice
				this.inventory = val.inventory
				this.tableData = val.barcode
				// console.log(this.tableData)
				this.setData().then(res => {
					// console.log('22')
					// JsBarcode('.barcode').init()
					res.forEach((e, index) => {
						JsBarcode('#barcode' + index, e.barcode, {
							format: 'CODE128', // 条形码的格式
							// lineColor: '#0aa', // 线条颜色
							// width: 4, // 线宽
							height: 20, // 条码高度
							displayValue: true // 是否显示文字信息
						})
					})
				})
			},
			immediate: true
		}
	},
	mounted () {
		// this.setData().then(res => {
		// 	console.log('11')
		// 	// JsBarcode('.barcode').init()
		// 	res.forEach((e, index) => {
		// 		JsBarcode('#barcode' + index, e.barcode, {
		// 			format: 'CODE128', // 条形码的格式
		// 			// lineColor: '#0aa', // 线条颜色
		// 			// width: 4, // 线宽
		// 			height: 20, // 条码高度
		// 			displayValue: true // 是否显示文字信息
		// 		})
		// 	})
		// })
	},
	methods: {
		setData () {
			return new Promise(resolve => {
				resolve(this.tableData)
			})
		},
		channelInputLimit (e) {
			let key = e.key
			// console.log(e, 'aa')
			// console.log(key)
			// if (key === 'Process') {
			// 	e.returnValue = false
			// 	return false
			// }
			// 不允许输入'e'和'.'
			if (key === 'e' || key === '.' || key === '-') {
				e.returnValue = false
				return false
			}
			return true
		},
		barcodeInput (item, index) {
			this.tableData[index].barcode = this.tableData[index].barcode.replace(/[^\d]/g, '')
			item = item.replace(/[^\d]/g, '')
			if (item === '') {
				document.querySelector('#barcode' + index).innerHTML = ''
			} else {
				JsBarcode('#barcode' + index, item, {
					format: 'CODE128', // 条形码的格式
					// lineColor: '#0aa', // 线条颜色
					// width: 4, // 线宽
					height: 20, // 条码高度
					displayValue: true // 是否显示文字信息
				})
			}
		},
		minbuycntChange () {
			if (this.minbuycnt === undefined) {
				// console.log(1)
				this.$nextTick(() => {
					this.minbuycnt = 0
				})
			}
		},
		onBlur () {
			if (this.customePrice < 0) {
				this.customePrice = 0
			}
			let x = this.customePrice
			var f = Math.round(x * 100) / 100
			var s = f.toString()
			var rs = s.indexOf('.')
			if (rs < 0) {
				rs = s.length
				s += '.'
			}
			while (s.length <= rs + 2) {
				s += '0'
			}
			this.customePrice = s
		},
		onBlur1 () {
			if (this.inventory === '') {
				this.inventory = 0
			}
		},
		cancel () {
			this.$emit('cancel1', false)
		},
		save () {
			let barcodes = []
			for (var i = 0; i < this.tableData.length; i++) {
				if (this.tableData[i].barcode === '') {
					this.$message.error('商品条形码不能为空')
					return false
				} else {
					barcodes.push(this.tableData[i].barcode)
				}
			}
			let params = {
				id: this.editData.papid,
				inventory: this.inventory,
				customePrice: this.customePrice,
				minbuycnt: this.minbuycnt,
				barcodes: barcodes,
				shopid: this.shopid
			}
			this.$store.dispatch('requestPost', {
				url: `${this.$fxBaseApi.urlQIV}/shop/productUnit/update`,
				data: params
			}).then(res => {
				if (res.result === true) {
					this.tableData.forEach((e, index) => {
						e.productUnitBarCodeId = res.data[index].id
					})
					this.$message.success('保存成功')
					// this.$emit('cancel', false)
				} else {
					this.$message.error(res.msg)
				}
			})
		},
		// 新增
		addBarcode () {
			let add = { barcode: '' }
			this.tableData.push(add)
		},
		// 删除条形码
		delItem (item, index) {
			// if (!item.hasOwnProperty('productUnitBarCodeId')) {
			// 	this.tableData.splice(index, 1)
			// } else {
			this.$confirm(`是否要删除该条形码?`, '提示', {
				confirmButtonText: '确定',
				cancelButtonText: '取消',
				type: 'warning',
				closeOnClickModal: false
			}).then(() => {
				let params = {
					productUnitBarCodeId: item.productUnitBarCodeId
				}
				this.$store.dispatch('requestPost', {
					url: `${this.$fxBaseApi.urlQIV}/shop/productBarcode/remove`,
					data: params
				}).then(res => {
					if (res.result === true) {
						this.tableData.splice(index, 1)
						this.tableData.forEach((e, index) => {
							if (e.barcode) {
								JsBarcode('#barcode' + index, e.barcode, {
									format: 'CODE128', // 条形码的格式
									// lineColor: '#0aa', // 线条颜色
									// width: 4, // 线宽
									height: 20, // 条码高度
									displayValue: true // 是否显示文字信息
								})
							} else {
								JsBarcode('#barcode' + index, ' ', {
									format: 'CODE128', // 条形码的格式
									// lineColor: '#0aa', // 线条颜色
									// width: 4, // 线宽
									height: 0, // 条码高度
									displayValue: true // 是否显示文字信息
								})
							}
						})
						this.$message.success('删除成功')
						// this.$emit('cancel', false)
					} else {
						this.$message.error(res.msg)
					}
				})
			}).catch(() => {

			})
			// }
		}
	}
}
</script>

<style lang="stylus" scoped>
.file-dialog-body {
	padding-left :17px;
	display: flex;
    flex-direction: column;
	.file-dialog-content {
		max-height: 450px;
		overflow-y: auto
	}
    .span-box{
		overflow: hidden;
		text-overflow:ellipsis;
		white-space: nowrap;
        margin-left :100px;
        height :40px;
        line-height :40px
        .input-box{
            width :140px
        }
    }
	p {
        float :left;
        width :100px;
        text-align :right;
		margin:10px 10px;
	}
	.btn {
		width: 150px;
		margin-left: 55px
		margin-top :50px
	}
	.isRed >>> .el-input__inner{
		color:red
	}
}
</style>
